import React, {Component} from 'react';
import { Grid, Button,Fade, Paper, Collapse,LinearProgress} from "@material-ui/core";
import { connect } from "react-redux";
import DialogContent from "@material-ui/core/DialogContent";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import FileUpload from "components/Files/Upload";
import { addLibor, getLibor, getLiborExcel } from "store/state/libor";

class ResetTestData extends Component {
  state = {
    error: ''    
  }
  componentDidMount() {
    const { getLibor } = this.props;
    getLibor();
  }

  handleUpload = files => {
    const {
      authentication: {
        user: { id }
      }
    } = this.props;
    this.props.addLibor("libor", id, files[0], "/libor/upload/test");
  };

  renderFileUpload = () => {
    const {isLoading} = this.props;            
    const theStyle = {
      minWidth:400
    }
    return (
      <React.Fragment>
      <div style={theStyle}>
      <Collapse in={!isLoading}>
        <Paper elevation={1}>
          <FileUpload onDrop={this.handleUpload} />
        </Paper>
      </Collapse>
      <Fade in={isLoading}>
        <Paper elevation={1}>
          <LinearProgress />
        </Paper>
      </Fade>
      </div>
      </React.Fragment>
    );  
  }

  getXLSWorksheet = () => {
    const { getLiborExcel } = this.props;
    getLiborExcel();
  }

  render(){
    return (
      <form onSubmit={() => this.handleUpload()} id="submit_no_human">
        <DialogContent>
          <Grid container spacing={24}>
            <Grid item xs={12} sm={12}>
              <FormControl
                fullWidth
                error={this.state.error}
                style={{ width: "270px", maxWidth: "270px" }}
              >
                <FormHelperText
                  id="name-helper-text"
                  style={{ marginBottom: "20px" }}
                >
                  Sample file:{" "}
                  <Button onClick={this.getXLSWorksheet}>LIBOR-Upload-Model.xlsx</Button>
                </FormHelperText>
                {this.renderFileUpload()}       
                <FormHelperText id="name-helper-text">
                  {this.state.error}
                </FormHelperText>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
      </form>
    )
  }
}

const mapStateToProps = ({ authentication, libor, loading }) => ({
  authentication,
  libor,
  isLoading: loading.libor_upload
});

export default connect(
  mapStateToProps,
  { addLibor, getLibor, getLiborExcel }
)(ResetTestData);